import InputGroup from "@/components/ui/input-group";
import { Button } from "@/components/ui/button";
import { MdOutlineLocalOffer } from "react-icons/md";
import ApplyButton from "../buttons/apply-button";
import { useState } from "react";
import PromoCodeInput from "./promo-code-input";

const PromoCodeForm = () => {
  const [code, setCode] = useState<string>("");

  const handleApply = () => {
    if (!code.trim()) return;
    console.log("Applying code:", code);
    // здесь будет логика запроса
  };

  return (
    <div className="flex space-x-3">
      <PromoCodeInput value={code} onChange={setCode} />
      <ApplyButton onClick={handleApply} disabled={!code.trim()} />
    </div>
  );
};

export default PromoCodeForm;